import { Countries } from '../../../models/countries'
import { Roles } from '../../../models/roles'

export const NewsFilter = {
  TAG: {
    value: 'TAG',
    values: ['info', 'warning', 'incident'],
    name: 'news.add.typeSection.title',
    role: Roles.RESURS_ADMIN,
  },
  COUNTRY: {
    value: 'COUNTRY',
    values: [Countries.SE, Countries.NO, Countries.DK, Countries.FI],
    name: 'storeSettings.storeinfo.country',
  },
  PUBLISHED: {
    value: 'PUBLISHED',
    values: [true, false],
    name: 'news.list.published',
  },
}
